import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import { getCredentials, getCurrency, getCurrentPlanInfo, getLiceneInfo, getOrganizationInfo, getPlanPricing, getSubaccountCount, isAgentAccount, updateBillInfo, getPaymentVersion, parseJSON } from '../../Common/Appcommon';
import requestApiService from '../../services/requestApi.service';

const StepsContext = createContext();

const useStepsContext = () => useContext(StepsContext);

const StepsProvider = ({children}) => {

    /**
     * currentStep steps list
     * 
     *  1 - plans list page
     *  2 - billing page
     *  3 - confirm page
     *  4 - manage page
     *  5 - cancel page
     *  6 - current plan page
     *  7 - trail plan list page
     * 
     */
    const isAgency = isAgentAccount();
    const accountid = getOrganizationInfo("Account_ID");
    const appid = getOrganizationInfo("appid");
    const [version, setVersion] = useState("1.0");
    const [isUsage, setIsUsage] = useState(false);
    const [currentStep, setCurrentStep] = useState(1);
    const [noofMonth, setNoofMonth] = useState(1);
    const [showLoading, setShowLoading] = useState(false);
    const [stripePromise, setStripePromise] = useState(null);
    const [plansList, setPlansList] = useState([]);
    const [currentplan, setCurrentPlan] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState({});
    const [orgDetails, setOrgDetails] = useState({});
    const [licenseInfo, setLicenseInfo] = useState({});
    const [paymentDetails, setPaymentDetails] = useState({});
    const [currencyInfo, setCurrencyInfo] = useState({});
    const [subaccountCount, setSubaccountCount] = useState(0);
    const callPaymentFunc = useRef();
    let isFreePlan = parseInt(currentplan?.plan_cost) === 0;

    useEffect(() => {
        const fetchData = async () => {
            setShowLoading(true);
            const paymentVersion = await getPaymentVersion(isAgency);
            const plans = await getPlanPricing(isAgency);
            const currentplan = await getCurrentPlanInfo(isAgency);
            const currencyInfo = await getCurrency(isAgency);
            const licenseInfo = await getLiceneInfo();
            const orgData = getOrganizationInfo("all");
            if(paymentVersion === "1.0"){
                const stripe = await getCredentials(isAgency);
                setStripePromise(stripe);
            }
            setVersion(paymentVersion);
            setOrgDetails(orgData);
            setCurrentPlan(currentplan);
            await processPlansList(plans, currentplan)
            setLicenseInfo(licenseInfo);
            setPaymentDetails(licenseInfo[0]?.["paymentdetails"]);
            setCurrencyInfo(currencyInfo)
            setShowLoading(false);
        }
        fetchData();
    }, []);

    const processPlansList = async (planslist, currentplan) => {
        if(isAgency){
            if(Object.keys(currentplan).length > 0){
                let plan_type = currentplan.plan_type;
                if(plan_type && plan_type === "LTD"){
                    let cost_limit = currentplan.plan_cost;
                    if(typeof(cost_limit) === "string" && cost_limit !== ""){
                        cost_limit = parseInt(cost_limit);
                    }
                    if(cost_limit !== 0){
                        // planslist with cost greater than or equal 3000
                        planslist = planslist.filter(plan => {
                            let type = parseJSON(plan.type);
                            let cost = parseInt(plan.plan_cost);
                            type = type.value;
                            if((type === "Subscription" && cost === 0) || parseInt(plan.plan_cost) >= cost_limit){
                                return plan;
                            }
                        });
                    }
                }
            }else{
                // for trail customers
            }
            let data = await getSubaccountCount();
            setSubaccountCount(data[0])
        }
        setPlansList(planslist);
    }

    const handleSubmitClick = async () => {
        if(!showLoading){
            await updateBillInfo(orgDetails, paymentDetails);
            if(version === "1.0"){
                if (callPaymentFunc.current) {
                    setShowLoading(true);
                    let result = await callPaymentFunc.current.processPayment();
                    if(result){
                        setCurrentStep(3);
                    }
                    setShowLoading(false);
                }else{
                    setCurrentStep(3);
                }
            }else if(version === "2.0"){
                createCheckoutPage();
            }
        }
    };

    const createCheckoutPage = async () => {
        const params = {
            ENTITY: "STRIPE_PROCESSOR",
            OPERATION: "CREATE_CHECKOUT_PAGE",
            currency: currencyInfo.value,
            isAgency: isAgency,
            selectedPlan: selectedPlan,
            billingDetails: orgDetails,
            noofMonths: noofMonth,
            version: version,
            current_domain: window.location.origin,
            isOtherApiReq: true,
        };
        try {
            setShowLoading(true);
            let response = await requestApiService.processServerRequest(params);
            setShowLoading(false);
            if (response.issuccess) {
                let url = response.data;
                if((typeof(url) === "string" && url !== "") || (typeof(url) === "object" && url.length > 0)){
                    window.open(url, "_blank");
                }else if(typeof(url) === "boolean" && url){
                    setCurrentStep(6);
                }
            }
        } catch (error) {
            console.error("Error Create Checkout Page:", error);
        }
    }

    return (
        <StepsContext.Provider
            value={{
                isAgency,
                currentStep,
                setCurrentStep,
                plansList,
                noofMonth, 
                setNoofMonth,
                stripePromise,
                currentplan,
                setCurrentPlan,
                selectedPlan, 
                setSelectedPlan,
                orgDetails, 
                setOrgDetails,
                showLoading, 
                setShowLoading,
                paymentDetails,
                setPaymentDetails,
                accountid,
                appid,
                callPaymentFunc,
                isUsage,
                setIsUsage,
                handleSubmitClick,
                currencyInfo,
                subaccountCount,
                processPlansList,
                version,
                isFreePlan
            }}
        >
            {children}
        </StepsContext.Provider>
    );
}

export { useStepsContext, StepsProvider };
